import React, { useRef } from 'react';
import { MainToolbar } from './main.toolbar';

export const FixedToolbar = ({ toolbarRef, toolbar, onOpenLinkModal, uploadAttachments, inlineRight = false }) => {
  const ref = useRef(null);

  const setRef = (el) => {
    ref.current = el;
    if (toolbarRef) toolbarRef.current = el;
  };

  const handleMouseDown = (e) => {
    // Allow native <select> and color <input> to open; prevent default for buttons so editor keeps focus
    if (e.target.matches('select, input[type="color"]')) return;
    e.preventDefault();
  };

  return (
    <div
      className={`text-editor__fixed-toolbar ${inlineRight ? 'text-editor__fixed-toolbar--inline-right' : ''}`}
      onMouseDown={handleMouseDown}
      ref={setRef}
    >
      <MainToolbar
        toolbar={toolbar}
        buttonClassName="text-editor__toolbar-button"
        onOpenLinkModal={onOpenLinkModal}
        uploadAttachments={uploadAttachments}
      />
    </div>
  );
};
